export default "__VITE_ASSET__CUwQAcHn__";